import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import timeFilter from './filters/time'

// MaterialアイコンのSVGをDownloadして使っている
// by https://iritec.jp/web_service/14859/
require('@/assets/fonts/style.css')

const userAgent = window.navigator.userAgent.toLowerCase();
if(
  (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) // IE
||(userAgent.indexOf('edge') != -1) // 旧Edge
) {
  window.location.href = 'https://amazekomae.com/unsupported-browser.html'
}

Vue.config.productionTip = false

// フィルター登録　https://zukucode.com/2017/04/vuejs-filter.html
Object.keys(timeFilter).forEach(key => {
  Vue.filter(key, timeFilter[key]);
});

new Vue({
  router,
  store,
  filters: timeFilter,
  render: h => h(App)
}).$mount('#app')
